import React, { FC } from 'react';
import { TabButtons } from '@/general/tab/buttons';
import { IProps } from '@/general/tab/buttons/types';
import styles from './styles.module.scss';

export const HeadTabs: FC<Omit<IProps, 'styles'>> = (props) => (
  <TabButtons styles={styles} aria-label="Pool navigation" {...props} />
);
